import React from "react";
import {
  Box,
  Typography,
  Divider,
  AppBar,
  Toolbar,
  IconButton,
  Stack,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";

const NoticePage = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  const handleBackButtonClick = () => {
    navigate(-1);
  };

  return (
    <Box
      width="100%"
      height="100vh"
      sx={{ backgroundColor: theme.palette.background.default }}
    >
      <AppBar position="static" color="primary">
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="back"
            onClick={handleBackButtonClick}
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography
            alignSelf="center"
            fontSize={"h6.fontSize"}
            fontWeight={"bold"}
          ></Typography>
        </Toolbar>
      </AppBar>

      <Stack>
        <Stack
          height={"10vh"}
          direction={"row"}
          alignItems={"center"}
          justifyContent={"center"}
          bgcolor={"#446785"}
          sx={{ color: "#f1fff2" }}
        >
          <AutoAwesomeIcon fontSize="medium" />
          <Typography marginX={1} fontSize={"h4.fontSize"} fontWeight={"bold"}>
            會員使用規範
          </Typography>
          <AutoAwesomeIcon fontSize="medium" />
        </Stack>
      </Stack>
      <Stack
        direction={"row"}
        height={"30vh"}
        alignItems={"center"}
        justifyContent={"center"}
        bgcolor={"#fcffd4"}
      >
        <Typography
          align="center"
          width={"15%"}
          sx={{ color: "#bfdbf3" }}
          fontSize={"h5.fontSize"}
          fontWeight={"bold"}
        >
          1
        </Typography>
        <Typography width={"15%"} fontSize={"h5.fontSize"} fontWeight={"bold"}>
          預約
        </Typography>
        <Divider
          orientation="vertical"
          variant="middle"
          flexItem
          sx={{ marginRight: 1 }}
        ></Divider>
        <Box width={"65%"}>
          <Typography fontSize={"12px"}>{`1. 會員同意預約即應收取包廂使用費用·由電子收費系統第三方支付,`}</Typography>
          <Typography fontSize={"12px"}>
            2. 會員同意預約到照常收費,不得延長時間另需延長時間費另計,若未按時預定,即视為同意屆時即停止使用該坐位:
          </Typography>
          <Typography fontSize={"12px"}>
            3. 會員同意取消預訂應於預定時間開始前2個小時前取消,未按本規則取消不得要求退费·若有得退费之情事會員同意以抵用卷方式支付,並同意不以現金退费·
          </Typography>
        </Box>
      </Stack>
      <Stack
        direction={"row"}
        height={"25vh"}
        alignItems={"center"}
        justifyContent={"center"}
        bgcolor={"#bfdbf3"}
      >
        <Typography
          align="center"
          width={"15%"}
          sx={{ color: "#fcffd4" }}
          fontSize={"h5.fontSize"}
          fontWeight={"bold"}
        >
          2
        </Typography>
        <Typography width={"15%"} fontSize={"h5.fontSize"} fontWeight={"bold"}>
          排隊規則
        </Typography>
        <Divider
          orientation="vertical"
          variant="middle"
          flexItem
          sx={{ marginRight: 1 }}
        ></Divider>
        <Box width={"65%"}>
          <Typography fontSize={"12px"}>
            1. 客滿時,願意等候及無預約再依現預約坐位,依預約方式取得時段為準。
          </Typography>
          <Typography fontSize={"12px"}>
            2. 同意以有預約為有優先權利。
          </Typography>
          <Typography fontSize={"12px"}>
            3. 現不得占用非約定之坐位影響他人使用、安靜等待。
          </Typography>
        </Box>
      </Stack>
      <Stack
        direction={"row"}
        height={"45vh"}
        alignItems={"center"}
        justifyContent={"center"}
        bgcolor={"#fcffd4"}
      >
        <Typography
          align="center"
          width={"15%"}
          sx={{ color: "#bfdbf3" }}
          fontSize={"h5.fontSize"}
          fontWeight={"bold"}
        >
          3
        </Typography>
        <Typography width={"15%"} fontSize={"h5.fontSize"} fontWeight={"bold"}>
          禁止事項
        </Typography>
        <Divider
          orientation="vertical"
          variant="middle"
          flexItem
          sx={{ marginRight: 1 }}
        ></Divider>
        <Box width={"65%"}>
          <Typography fontSize={"12px"}>
            會員承諾絕不為任何非法目的或以任何非法方式使用本服務,同意本公司服務場地禁止下列情事之規範:
          </Typography>
          <Typography fontSize={"12px"}>
            <strong>
              1. 禁止賭博或其他賭博性交易。<br />
              2. 禁止現金交易及非法行為。<br />
              3. 未成年請勿在上課時間及晚上10點後逗留。<br />
              4. 禁止破壞場地。<br />
              5. 禁使用毒品。<br />
              6. 除現垃圾外,禁止棄置私人垃圾:<br />
              .我們有停止您的體驗,且不退費。恕請配合!
            </strong>
          </Typography>
        </Box>
      </Stack>
      <Stack
        direction={"row"}
        height={"30vh"}
        alignItems={"center"}
        justifyContent={"center"}
        bgcolor={"#bfdbf3"}
      >
        <Typography
          align="center"
          width={"15%"}
          sx={{ color: "#fcffd4" }}
          fontSize={"h5.fontSize"}
          fontWeight={"bold"}
        >
          4
        </Typography>
        <Typography width={"15%"} fontSize={"h5.fontSize"} fontWeight={"bold"}>
          備註
        </Typography>
        <Divider
          orientation="vertical"
          variant="middle"
          flexItem
          sx={{ marginRight: 1 }}
        ></Divider>
        <Box width={"65%"}>
          <Typography fontSize={"12px"}>
            請注意以上的收費和租借則,如果有任何問需進一步的,請隨時聯聚我們
          </Typography>
          <Typography fontSize={"16px"} fontWeight={'bold'}>
            本體系EGO自助高爾夫俱樂部對所有規則擁有最終解釋,如遇不遵守館則的行為影響到他人,我們有權停止您的體驗。恕請配合!
          </Typography>
        </Box>
      </Stack>
    </Box>
  );
};

export default NoticePage;
